import { Fragment } from 'react';

// escapeRegExp is to avoid crashing errors
// it basically ensures that any special characters coming in inside value are considered to be a string
// as opposed to a regexp command (e.g. $/~ etc.)
const escapeRegExp = (value: string) =>
  value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

export const highlightSearchedValue = (
  label: string,
  highlightValue: string
) => {
  try {
    const safeHighlightValue = escapeRegExp(highlightValue);
    const labelParts = label.split(new RegExp(`(${safeHighlightValue})`, 'gi'));

    return labelParts.map(part =>
      part.toLowerCase() === highlightValue.toLowerCase() ? (
        <strong key={Math.random().toFixed(16)}>{part}</strong>
      ) : (
        <Fragment key={Math.random().toFixed(16)}>{part}</Fragment>
      )
    );
  } catch (e) {
    // oxlint-disable-next-line no-console
    console.warn('Regexp error: ', e);
    return label;
  }
};
